// Development-time warnings for misuse the types can't catch (a field with no name, an
// IconButton with no label). Vite replaces import.meta.env.DEV at build time, so production
// bundles drop them. Under node --test import.meta.env is undefined, so warnings are ON and
// a test can assert one with t.mock.method(console, 'warn'). Wave 1's components warn from
// useEffect, which renderToStaticMarkup never runs, so markup tests stay quiet; they assert
// the pure decision (missingNameWarning) instead.
export const DEV = import.meta.env?.DEV ?? true;

export function devWarn(message) {
  if (message && DEV) console.warn(`@platform/ui: ${message}`);
}
